import React from 'react'
import { usePlansContext } from '../../../../hooks/usePlansContext'
import { BodyCell } from '../BodyCell'

interface IndividualProps {
  children?: React.ReactNode
  className?: string
  spacing?: number
}

export const Individual = ({
  children,
  className,
  spacing,
}: IndividualProps) => {
  const { isIndividualSelected } = usePlansContext()

  return (
    <BodyCell
      className={className}
      isSelected={isIndividualSelected}
      spacing={spacing}
    >
      {children}
    </BodyCell>
  )
}
